import type {
  HeatmapAnalyticsQueryResponse,
  HeatmapAnalyticsQueryVariables,
} from '~/modules/heatmap/graphql/queries/heatmapAnalytics.generated';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { IHeatmapAnalytics } from '~/modules/heatmap/types';
import type { UseQueryOptions } from '@tanstack/react-query';

import { HeatmapAnalyticsDocument } from '~/modules/heatmap/graphql/queries/heatmapAnalytics.generated';
import { HEATMAP_QUERY_KEYS } from '../../websocket';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

export interface CustomHeatmapAnalyticsResponse extends Omit<
  HeatmapAnalyticsQueryResponse,
  'heatmapAnalytics'
> {
  heatmapAnalytics: IHeatmapAnalytics;
  headers: BaseHeaderResponse;
}

export const useCustomHeatmapAnalyticsQuery = <
  TData = CustomHeatmapAnalyticsResponse,
  TError = unknown,
>(
  variables: HeatmapAnalyticsQueryVariables,
  options?: UseQueryOptions<CustomHeatmapAnalyticsResponse, TError, TData>,
) => {
  return useQuery<CustomHeatmapAnalyticsResponse, TError, TData>(
    [HEATMAP_QUERY_KEYS.analytics, variables],
    appFetcherCustom<CustomHeatmapAnalyticsResponse, HeatmapAnalyticsQueryVariables>(
      HeatmapAnalyticsDocument,
      variables,
    ),
    options,
  );
};

useCustomHeatmapAnalyticsQuery.getKey = (variables?: HeatmapAnalyticsQueryVariables) => [
  HEATMAP_QUERY_KEYS.analytics,
  variables,
];
